// 0xGG Team
// Distributed under AGPL3
//
// DESCRIPTION: The error widget that displays the error message
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "react", "react-dom", "../component/widget"], function (require, exports, react_1, react_dom_1, widget_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ErrorWidget = void 0;
    react_1 = __importDefault(react_1);
    react_dom_1 = __importDefault(react_dom_1);
    var ErrorWidget = function (args) {
        var el = document.createElement("span");
        react_dom_1.default.render(react_1.default.createElement(widget_1.Widget, null,
            react_1.default.createElement("span", { style: { color: "#f50" } }, "EchoMD widget error: " + (args.attributes["message"] || "Unknown error"))), el);
        return el;
    };
    exports.ErrorWidget = ErrorWidget;
});
